<template>
  <a class="member-link no-suffix" :class="member.member ? 'member' : 'non-member'" :href="member.member ? '/company/'+member.slug : '#'">
    <div :data-title="member.name">
      <div class="row member-row">
        <div class="col-sm-auto my-auto">
          <img v-show="member.logo" :src="member.logo.startsWith('http') ? member.logo : member.s3PublicUrl+member.logo" alt="" class="logo" />
          <img
            v-show="!member.logo"
            src="/image-polaroid-duotone.svg"
            alt=""
            class="logo"
            style="opacity: 0.1"
          />
        </div>
        <div class="col-lg align-self-center">
          <div class="member-name">{{ member.name }}</div>
          <div v-html="address(member)"></div>
        </div>
        <div class="col-lg align-self-center contact">
          <div class="contact-essentials">
            <div class="phone" v-show="member.phone"><a class="no-suffix" :href="'tel:'+member.phone"><i class="fa fa-fw fa-phone-square" aria-hidden="true"></i> {{member.phone}}</a></div>
            <div class="phone" v-show="member.email"><a class="no-suffix" :href="'mailto:'+member.email"><i class="fa fa-fw fa-paper-plane" aria-hidden="true"></i> {{member.email}}</a></div>
            <div class="website" v-show="member.website" target="_blank"><a class="no-suffix" :href="member.website" target="_blank"><i class="fa fa-fw fa-globe" aria-hidden="true"></i> {{website(member)}}</a></div>
          </div>
          <div v-show="member.twitter || member.linkedIn || member.instagram || member.facebook" class="social mt-2">
            <a class="twitter no-suffix" v-show="member.twitter" :href="member.twitter" target="_blank"><i class="fab fa-fw fa-twitter" aria-hidden="true"></i></a>
            <a class="linkedIn no-suffix" v-show="member.linkedIn" :href="member.linkedIn" target="_blank"><i class="fab fa-fw fa-linkedin" aria-hidden="true"></i></a>
            <a class="instagram no-suffix" v-show="member.instagram" :href="member.instagram" target="_blank"><i class="fab fa-fw fa-instagram" aria-hidden="true"></i></a>
            <a class="facebook no-suffix" v-show="member.facebook" :href="member.facebook" target="_blank"><i class="fab fa-fw fa-facebook" aria-hidden="true"></i></a>
          </div>
        </div>
        <div class="col">
          <Contacts :member="member" />
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import Contacts from './Contacts'
export default {
  props: {
    member: {
      type: Object,
    },
  },
  components: {
    Contacts,
  },
  methods: {
    address(member) {
      const addr = []
      if (member.address1) {
        addr.push(member.address1)
      }
      if (member.address2) {
        addr.push(member.address2)
      }
      const cityProvincePostal = []
      if (member.city) {
        cityProvincePostal.push(member.city)
      }
      if (member.province) {
        cityProvincePostal.push(member.province)
      }
      if (member.postcode) {
        cityProvincePostal.push(member.postcode)
      }
      const cityProvincePostalLine = cityProvincePostal.join('  ')
      addr.push(cityProvincePostalLine)
      return addr.join('<br>')
    },
    website(member) {
        if(!member.website) {
          return ''
        }
        let link = member.website.replace(/^\/\/|^.*?:(\/\/)?/, '')
        link = link.replace(/\/$/, '');
        return link
      }
  },
}
</script>

<style lang="scss" scoped>
a:hover {
  color: #e64c61;
  cursor: pointer;
  transition: color 1s ease
}
.member-link.non-member:hover {
  color: #2c3e50;
  cursor: not-allowed;
}
.member-row {
  padding: 0 20px;
}
.logo {
  width: 100px;
  max-height: 100px;
  margin: 10px 10px 10px 0;
}
.member-name {
  font-size: 1.1em;
  font-weight: bold;
}
.contact {
  font-size: 0.9em;
}
.website {
  white-space: nowrap;
}
.contact-essentials {
  margin-bottom: 8px;
}
a {
  text-decoration: none;
  color: #2c3e50;
}
.contact-essentials i {
  color: #ccc
}
.contact-essentials a:hover i {
  color: #888;
  transition: color 1s ease
}
.social a {
  margin-right: 3px;
}
.twitter {
  color: #0084b4;
}
.linkedIn {
  color: #0D4FB5;
}
.facebook {
  color: #3B5998;
}
.instagram {
  color: #C13584;
}
</style>